import Head from 'next/head'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

import Layout from '../../components/layout-components/homeLayout/Layout'
import Italy from '../../components/shared-components/privacy/Italy'

const PrivacyAndPolicy = () => {
  return (
    <>
      <Head>
        <title>Smartcaf | politica sulla riservatezza</title>
        <link rel='icon' href='/favicon.ico' />
        <meta
          name='description'
          content='Evita le code, siamo il primo CAF in Italia completamente online!'
        />
      </Head>

      <div className='privacy-pg py-50'>
        <div className='container mx-auto'>
          <Italy />
        </div>
      </div>
    </>
  )
}

PrivacyAndPolicy.Layout = Layout
export default PrivacyAndPolicy

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['HomeLayout'])),
    },
  }
}
